module.exports = "/_next/static/images/tz-53855cd86197a1dac824a856f29ead47.svg";